import React from 'react';

import './AnswerInterface.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { handleFieldChange } from '../../../utils/forms';

export default function AnswerInterface(props) {

	const {
			answer,
			hasAnsweredCallback,
			answerSet,
			setQOptDone,
			resetAnswer,
			optionIndex
	 	} = props,
		[fields, setFields] = useState({answer:''}),
		[answerSelected, setAnswerSelected] = useState(false),
		[answerSelectedIndex, setAnswerSelectedIndex] = useState(null),
		[showAnswerCN, setShowAnswerCN] = useState(''),
		[hasAnsweredCorrectly, setHasAnsweredCorrectly] = useState(false),
		handleInputChange = handleFieldChange(fields, setFields),
		handleAnswerClick = (ans,index) => {

			//prevent click
			if(answerSelected) {
				return ()=>{};
			}
			
			return (evt)=>{
				evt.preventDefault();
				evt.stopPropagation();
				
				setFields({answer:ans});
				setAnswerSelected(true);
				setAnswerSelectedIndex(index);
				setHasAnsweredCorrectly(answer===ans);
			}
		},
		renderAnswerInterface = ()=>{
			if(answerSet) {
				// console.log('renderAnswerInterface', answerSet);
				//render buttons
				return (
					<ul className={'answer-buttons-interface ' + showAnswerCN}>
						{answerSet.map((item,index)=>
							<li 
								key={"aui"+index} 
								onClick={item.show ? handleAnswerClick(item.label,index) : ()=>{}} 
								className={(item.label===answer?'correct ':'') + (parseInt(answerSelectedIndex)===index?'selected':'') + (item.show? '':' answered')}
								>
									<a>{item.label}</a>
							</li>
						)}
					</ul>
				);
			}

			//render input field
			return <input 
						type="text" 
						className={'answer ' + showAnswerCN} 
						disabled={answerSelected} 
						name="answer" 
						onChange={handleInputChange} 
						value={fields.answer.toUpperCase()} 
						/>;
		};

	// console.log('AnswerInterface props', props, fields);

	useEffect(()=>{
		if (fields.answer.length === (answer && answer.length) || 0) {
			setAnswerSelected(true);
		}
	});

	useEffect(()=>{

		if (answerSelectedIndex !== null) {
			setQOptDone(fields.answer, optionIndex);
		}

	}, [answerSelectedIndex])

	useEffect(()=>{
		if (answerSelected) {
			const isCorrectAnswer = fields.answer.toUpperCase() === answer.toUpperCase();
			setShowAnswerCN(isCorrectAnswer?'show-status correct':'show-status');
			hasAnsweredCallback(fields.answer, hasAnsweredCorrectly);
		}

		if (resetAnswer) {
			setShowAnswerCN('');
			setFields({answer:''});
			setAnswerSelected(false);
			setAnswerSelectedIndex(null);
		}

	},[answerSelected, resetAnswer]);

	return (
		<div className='answer-container'>
		{renderAnswerInterface()}
		</div>
	);
}